import { Box, Typography } from "@mui/material";
import type { ParameterDictionaryValue, WorkbookFilter } from "../../../../../../api/types/workbookRuns.types";
import { toLabel } from "../../../../dashboard/utils/withValue";
import ConditionBlockWorkbookFilter from "./ConditionBlockWorkbookFilter";

interface Props {
  value?: ParameterDictionaryValue;
  workbookFilter?: WorkbookFilter;
  color?: string;
}
const ConditionBlockValueItem = ({ value, workbookFilter, color }: Props) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, minWidth: 0 }}>
      <Typography variant="caption" sx={{ color: color }}>
        {toLabel(value)}
      </Typography>
      {workbookFilter && <ConditionBlockWorkbookFilter workbookFilter={workbookFilter} />}
    </Box>
  );
};

export default ConditionBlockValueItem;
